import React from 'react'

export type Props = {
  children: React.ReactNode
}

export const NavigationItem = ({ children }: Props) => {
  return <li className='header__navigation_item'>{children}</li>
}
